export enum LabRemoteConfigKeys {
  societeCampaign = 'lebt:societecampaign',
}
